module.exports = __webpack_public_path__ + "img/fyt_p18.dd16cad7.png";